import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-template-form',
    templateUrl: './template-form.component.html',
    styleUrls: ['./template-form.component.scss'],
    standalone: false
})
export class TemplateFormComponent implements OnInit {

    @Input() title: string = '';
    @Input() subtitle: string = '';
    @Input() styleWidth: number = -1;
    @Input() padding: string | undefined;

    constructor() {
    }

    ngOnInit(): void {
    }

    get width() {
        if (this.styleWidth >= 0) {
            return (this.styleWidth > window.innerWidth) ? 'auto' : this.styleWidth + 'px';
        } else {
            return null;
        }
    }

}
